<template>
  <tr>
    <th v-if="title" scope="col">
      <div :style="{ width: '90px' }">{{ title }}</div>
    </th>
    <td>
      <!-- <div class="column-w" :style="{ width: '1250px', overflow: 'hidden' }"> -->
      <div class="column-w" :style="{ overflow: 'hidden' }">
        <div
          class="ck ck-content ck-editor__editable ck-rounded-corners ck-editor__editable_inline ck-blurred"
          lang="en"
          dir="ltr"
          role="textbox"
          aria-label="Rich Text Editor, main"
          contenteditable="false"
          :style="{ width: '1300px', maxHeight: '100%' }"
          v-html="content"
        ></div>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    content: {
      type: String,
      required: false,
    },
  },
  mounted() {
    this.initClickImg();
  },
  methods: {
    initClickImg() {
      let imgList = document.querySelectorAll('img');

      for (let i = 0; i < imgList.length; i++) {
        let img = imgList[i];
        img.onload = function() // 이미지 로딩 완료 시 실행되는 함수
        {
          //var width = myImg.width; // 정확한 이미지 폭 알 수 있음.
          //img.addEventListener('click', this.image_popup(img.src));
          img.addEventListener('click', function() {
            var imgObj = new Image();
            imgObj.src = img.src;
            // let imageWin = window.open(
            //   '',
            //   'profile_popup',
            //   'width=' +
            //     img.naturalWidth +
            //     'px, height=' +
            //     img.naturalHeight +
            //     'px',
            // );
            let imageWin = window.open(
              '',
              'profile_popup',
              'width=' +
                window.innerWidth +
                'px, height=' +
                window.outerHeight +
                'px',
            );
            imageWin.document.write("<html><body style='margin:0'>");
            imageWin.document.write(
              "<a href=javascript:window.close()><img src='" +
                imgObj.src +
                "' border=0 style='width: 100%;'></a>",
            );
            imageWin.document.write('</body><html>');
            imageWin.document.title = imgObj.src;
          });
        };
      }
    }
  }
};

</script>
